// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"835f9ce8","732":"1fdaf99e","977":"b726fb31"}[chunkId] + ".chunk.js";
};